import type { IProjectRepository, ProjectUpdateInput } from '../repositories/IProjectRepository.js';
import type { ProjectEntity } from '../entities/ProjectEntity.js';

export interface UpdateProjectInput {
  id: string;
  data: ProjectUpdateInput;
}

interface Deps { projectRepository: IProjectRepository; }

export function createUpdateProjectUseCase({ projectRepository }: Deps) {
  return async function updateProject({ id, data }: UpdateProjectInput): Promise<ProjectEntity | null> {
    return projectRepository.update(id, data);
  };
}
